import TipoInvestimento from '../../../../spa/tipo-investimento/TipoInvestimento';

export default {
  path: 'tipo-investimento',
  name: 'tipo-investimento',
  component: TipoInvestimento,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/tipo-investimento.js